import { gql } from "@apollo/client";

export const REFRESH_PROFILE_PICTURE = gql`
  mutation RefreshProfilePicture($instagramUsername: String!) {
    refreshProfilePicture(instagramUsername: $instagramUsername) {
      id
      profileImageUrl
    }
  }
`;

export interface RefreshProfilePictureData {
  refreshProfilePicture: {
    id: string;
    profileImageUrl: string | null;
  };
}

export interface RefreshProfilePictureVariables {
  instagramUsername: string;
}
